// Modal.js
import { useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = "md", // sm | md | lg | xl | full
  position = "center", // center | top-right
  closable = true,
  closeOnOverlayClick = true,
}) => {
  const modalSizes = {
    sm: "400px",
    md: "600px",
    lg: "800px",
    xl: "1000px",
    full: "90%",
  };

  // Close on ESC key
  useEffect(() => {
    if (!isOpen) return; // only attach when modal is open

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);

    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={`modal-overlay modal-position-${position}`}
      onClick={closeOnOverlayClick ? onClose : undefined}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`modal-content modal-position-${position}`}
        style={{ width: modalSizes[size] }}
        onClick={(e) => e.stopPropagation()} // prevent overlay close on content click
      >
        {/* Header */}
        <div className="modal-header">
          {title && (<h4 className="modal-title">{title}</h4>)}
          {closable && (
            <button
              className="modal-close-button cursor-pointer"
              type="button"
              onClick={onClose}
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          )}
        </div>

        {/* Body */}
        <div className="modal-body">{children}</div>

        {/* Footer */}
        {footer && <div className="modal-footer mt-2">{footer}</div>}
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default Modal;
